export const propertyTemplateUtils = {
    /**
     * Ensures a handler name has the Global.PROPERTYTEMPLATE. prefix
     * @param {string} handler - The handler name
     * @returns {string} - The namespaced handler name
     */
    addGlobalNamespace: function(handler) {
        if (!handler) return handler;
        return handler.startsWith("Global.PROPERTYTEMPLATE.") 
            ? handler 
            : "Global.PROPERTYTEMPLATE." + handler;
    },

    /**
     * Removes the Global.PROPERTYTEMPLATE. prefix if present
     * @param {string} namespacedHandler - The namespaced handler name
     * @returns {string} - The handler name without namespace
     */
    removeGlobalNamespace: function(namespacedHandler) {
        if (!namespacedHandler) return namespacedHandler;
        return namespacedHandler.startsWith("Global.PROPERTYTEMPLATE.")
            ? namespacedHandler.substring("Global.PROPERTYTEMPLATE.".length)
            : namespacedHandler;
    }
};